import {createAsyncThunk} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {ProductPricesType} from 'desktop/types/typesProduct';
import {apiConfig} from 'libs/api/api';

/**
 * Get all quicklook data with "addToCart" button for upsell item
 * @param {number} productId productId
 * @param {any} handler - handler to click button
 * @param {ProductPricesType} newPrices - for display upsell offer 50%
 * @returns {AjaxActionType} action
 */
export const getQuickLookWithAddToCart = createAsyncThunk<
    unknown,
    {productId: number; handler: Function; newPrices: ProductPricesType}
>('QUICKLOOK@GET_QUICKLOOK', async ({handler, newPrices, productId}) => {
    const {dispatch} = apiConfig.hostStore;

    dispatch({
        type: 'QUICKLOOK@GET_QUICKLOOK_PENDING',
    });

    try {
        const response = await apiConfig.instanceGusaBackend({
            method: 'GET',
            transformResponse: data => ({
                buttonHandler: handler,
                data: {
                    ...JSON.parse(data),
                    finalPrice: newPrices.finalPrice,
                    price: newPrices.price,
                },
            }),
            url: `${ENDPOINTS.QUICKLOOK_GET}/${productId}`,
        });

        dispatch({
            payload: response,
            type: 'QUICKLOOK@GET_QUICKLOOK_FULFILLED',
        });
        return response;
    } catch (e) {
        dispatch({type: 'QUICKLOOK@GET_QUICKLOOK_REJECTED'});
        throw e;
    }
});

/**
 * Close quick look
 * @returns {ActionType} action
 */
export function closeQuickLook() {
    const {dispatch} = apiConfig.hostStore;

    dispatch({
        type: 'QUICKLOOK@CLOSE_QUICKLOOK',
    });
}
